<template>
  <div class="smart-display">
    <h1>{{ msg }}(工事中)</h1>

    <p>
     「トークA愛」の製品取扱説明を行います。
    </p>


    <h3>
    スマートホームのお勉強
    </h3>

    <div class="talka">

    <h4>
    もくじ
    </h4>

      <ol>
      <li>
      <router-link to="/study/firebase_overview">firebaseの概要</router-link>
      </li>
      <li>
      <router-link to="/study/smart_home_overview">スマートホーム（クラウド制御）の概要</router-link>
      </li>
      <li>
      <router-link to="/study/local_home_overview">スマートホーム（ローカル制御）の概要</router-link>
      </li>
      <li>
      <router-link to="/study/smart_home">スマートホーム洗濯機の例（クラウド制御）</router-link>
      </li>
      <li>
      <router-link to="/study/local_home">スマートホーム洗濯機の例（ローカル制御）</router-link>
      </li>
      <li>
      <router-link to="/study/javascript_async_await">JavaScriptの同期処理</router-link>
      </li>
      <li>
      <router-link to="/study/local_fulfillment">Local fulfillment</router-link>
      </li>
      </ol>

    <h2>
    1. 概要
    </h2>

    <h3>
    1.1 コンテンツの種類
    </h3>

      <h4>
      参考リンク
      </h4>

      <ol>
      <li>
      コンテンツには、以下の種類があります。
      <ul>
      <li>
      カテゴリ
      </li>
      <li>
      演奏者
      </li>
      <li>
      アルバム
      </li>
      <li>
      曲名
      </li>
      </ul>
      </li>
      </ol>

    <h3>
    1.2 コンテンツの構造
    </h3>

      <ol>
      <li>
      コンテンツの階層構造は、以下のようになっています。
      <ul>
      <li>
      カテゴリ
      </li>
      <li>
      演奏者
      </li>
      <li>
      アルバム
      </li>
      <li>
      曲名
      </li>
      </ul>
      </li>
      </ol>

    <h2>
    2. 画面構成
    </h2>

    <h3>
    2.1 ホーム画面
    </h3>

      <ol>
      <li>
      ホーム画面では、左右に選択メニューがあります。
      </li>
      <li>
      左側の選択メニューでは、「カテゴリ」と「演奏者」を指定します。
      </li>
      <li>
      右側の選択メニューでは、「アルバム」と「曲名」を指定します。
      </li>
      </ol>

      <h4>
      参考リンク
      </h4>

      <ol>
      <li>
      <a href="https://vstone.co.jp/robotshop/blog/archives/852">Nest MiniでLocal Home SDKを使ってお家のIoTロボットを操作する 第1回</a>
      </li>
      <li>
      <a href="https://vstone.co.jp/robotshop/blog/archives/894">Nest MiniでLocal Home SDKを使ってお家のIoTロボットを操作する 第2回</a>
      </li>
      <li>
      <a href="https://vstone.co.jp/robotshop/blog/archives/950">Nest MiniでLocal Home SDKを使ってお家のIoTロボットを操作する 第3回</a>
      </li>
      <li>
      <a href="https://vstone.co.jp/robotshop/blog/archives/993">Nest MiniでLocal Home SDKを使ってお家のIoTロボットを操作する 第4回</a>
      </li>
      <li>
      <a href="https://vstone.co.jp/robotshop/blog/archives/1029">Nest MiniでLocal Home SDKを使ってお家のIoTロボットを操作する 第5回</a>
      </li>
      </ol>

    </div>

  </div>

</template>

<script>
import Vue from 'vue'
import VueYoutube from 'vue-youtube'

Vue.use(VueYoutube)

export default {
  name: 'DanceWorld',
  props: {
    msg: String
  },
  data() {
    return {
      albumIndex: 0,
      albumTitle : 'ワルツ',
      videoIndex: 0,
      videoTitle : '01 いきいきストレッチング',

      //videoIndex_1: 0,
      videoId: '5IlfzLYadNk',

      albums: [],
    }
  },
  created () {
    //this.albums = [this.album_1, this.album_2, this.album_3, this.album_4, this.album_5, this.album_6, this.album_7]
    //this.firstVideo()
  },
  methods: {
  
    selectAlbum(index) {
      window.console.log("selectAlbum() 1.index: " + index);
      this.albumIndex = index;
      this.firstVideo()
    },

  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.smart-display {
  //margin-left: 20px;
}

.talka {
  margin-left: 10px;
}

pre {
   background-color: #ffffaa;
}

h3 {
  margin: 40px 0 0;
}
ol {
  //list-style-type: none;
  padding: 0;
  margin-left: 20px;
}
ul {
  //list-style-type: none;
  padding: 0;
}
li {
  //display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
